import React from 'react'
import './banner.css'

const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const Theme5NoPhotoBanner = ({values}) => {
   const isLargeNameFont = LARGE_NAME_FONTS.includes(
  values?.nameFontStyle
); 
    const noPhotoGroomNameDisplay = () => {
    return (
      <h3
          className={`t5-preview-cover-name ${
        isLargeNameFont ? "t5-preview-cover-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
          {values.groomName || "Groom"}
      </h3>
    );
  };

   const noPhotoBrideNameDisplay = () => {
    return (
      <h3
          className={`t5-preview-cover-name ${
        isLargeNameFont ? "t5-preview-cover-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
        {values.brideName || "Bride"}
      </h3>
    );
  };

  return (
    <>
    <picture>
  {/* Desktop */}
  <source
    media="(min-width: 768px)"
    srcSet={`
      https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1789009461/aamantran%20assets/desktop_hero_frame_1_oqbmkh.png 1080w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_1920/v1789009461/aamantran%20assets/desktop_hero_frame_1_oqbmkh.png 1920w
    `}
    sizes="100vw"
  />

  {/* Mobile */}
  <img
    src="https://res.cloudinary.com/depixc8dq/image/upload/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png"
    srcSet={`
      https://res.cloudinary.com/depixc8dq/image/upload/w_320/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png 320w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_640/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png 640w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png 1080w
    `}
    sizes="100vw"
    className="theme-preview-5-cover-frame"
    alt="cover background"
  />
</picture>
 <div className="t5-preview-cover-details">
 <div className="t5-preview-ineer-content">

   <span className="t5-no-photo-preview-cover-content">
          We are honored to welcome you to the wedding ceremony of
        </span>
          <div className="t5-preview-cover-name-wrapper">
            {values.displayOrder==="groomFirst"?(
          <>
               {noPhotoGroomNameDisplay()}
                <span 
                   className={`t5-preview-cover-and ${
        isLargeNameFont ? "t5-preview-cover-and--compact" : ""
      }`}
                 style={{ fontFamily: values.nameFontStyle }}>&</span>
                   {noPhotoBrideNameDisplay()}

          </>
         ):<>
    {noPhotoBrideNameDisplay()}
                <span 
                       className={`t5-preview-cover-and ${
        isLargeNameFont ? "t5-preview-cover-and--compact" : ""
      }`}
                 style={{ fontFamily: values.nameFontStyle }}>&</span>
                  {noPhotoGroomNameDisplay()}
         </>}
        
          </div>
           <div className="t5-preview-cover-hashtag">  
             {values.hashtag ? `#${values.hashtag}` : ""}
           </div>
 </div>
  
 </div>
</>
  )
}

export default Theme5NoPhotoBanner